// extracted by mini-css-extract-plugin
export default {"hobbies":"hobbies__KI0kh","hobby":"hobby__i1Vxl"};